(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-offer-stack"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__lpOfferBound) return;
    window.__lpOfferBound = true;

    document.addEventListener('submit', async function (event) {
      var form = event.target.closest && event.target.closest('.js-lp-offer-form');
      if (!form || !window.fetch) return; // no JS enhancement -> native POST to /cart/add still works
      event.preventDefault();

      var button = form.querySelector('[type="submit"]');
      if (button) { button.setAttribute('aria-busy', 'true'); button.disabled = true; }

      try {
        var res = await fetch(form.action, {
          method: 'POST',
          headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        });
        var data = await res.json();
        // Let the Horizon theme refresh the cart drawer / totals.
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { source: 'lp-offer-stack', item: data } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (err) {
        window.location.href = '/cart'; // fail open — the CTA never dies
      } finally {
        if (button) { button.removeAttribute('aria-busy'); button.disabled = false; }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
